import { render, staticRenderFns } from "./checklist_statement_table.vue?vue&type=template&id=2ce84aa4&scoped=true"
import script from "./checklist_statement_table.vue?vue&type=script&lang=js"
export * from "./checklist_statement_table.vue?vue&type=script&lang=js"
import style0 from "./checklist_statement_table.vue?vue&type=style&index=0&id=2ce84aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce84aa4",
  null
  
)

export default component.exports